<template>
    <b-row>
        <b-col>
            <b-form-group
                    :id="name"
                    :label="label"
                    :label-for="name">
                <div v-if="inline">
                    <b-input-group @click="openGallery">
                        <b-form-input id="selected-img-path"
                                      placeholder="Select or upload image..."
                                      v-b-modal.gallery
                                      readonly
                                      type="text"
                                      :value="value"
                                      required>
                        </b-form-input>
                        <b-input-group-append>
                            <b-button variant="outline-secondary"><i
                                    class="fal fa-images"></i></b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div v-else class="image">
                    <div class="stage" @click="openGallery">
                        <b-img v-if="value" fluid-growth center :src="fileResourceUrl(value)" thumbnail
                               alt="Responsive image"></b-img>
                        <b-button v-else><i class="fal fa-plus"></i> Select Image </b-button>
                    </div>
                </div>
            </b-form-group>
            <b-modal ref="gallery"
                     size="xl"
                     cancel-only="true"
                     title="Gallery">
                <image-gallary key="gallery" :selectImageCallback="selectImageCallback"/>
            </b-modal>
        </b-col>
    </b-row>
</template>

<script>
    import ImageGallery from "../../../components/ImageGallery";

    export default {
        name: 'ImageInput',
        props: ['placeholder', 'label', 'name', 'value', 'inline'],
        methods: {
            selectImageCallback(imgName) {
                this.$emit('input', imgName);
                this.$refs.gallery.hide();
            },
            openGallery: function () {
                this.$refs.gallery.show();
            }
        }, components: {
            'image-gallary': ImageGallery
        },
    }

</script>

<style lang="scss" scoped>
    .stage {
        overflow: auto;
        padding: 20px;
        background: #F1F1F1;
        position: relative;
        cursor: pointer;
        text-align: center;
        .image {
            height: 200px;
        }
    }
</style>